// This file is auto-generated by @hey-api/openapi-ts
import { client } from './client.gen';
export class AppService {
    /**
     * Get hello
     *
     * Simple endpoint that returns a "Hello World" greeting, used for basic connectivity testing.
     */
    static getHello(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/',
            ...options
        });
    }
}
export class SettingsService {
    /**
     * Get application settings
     *
     * Retrieves the current global application configuration settings.
     */
    static getSettingsV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/settings',
            ...options
        });
    }
    /**
     * Update application settings
     *
     * Updates the global application configuration settings.
     */
    static updateSettingsV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/settings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Load fixtures (V3)
     *
     * Development utility to populate the database with version 3 test data.
     */
    static loadFixturesV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/settings/fixtures',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Load fixtures (V2)
     *
     * Development utility to populate the database with version 2 test data.
     */
    static loadFixtures(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/settings/fixtures',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3SettingsService {
    /**
     * Get application settings
     *
     * Retrieves the current global application configuration settings.
     */
    static getSettingsV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/settings',
            ...options
        });
    }
    /**
     * Update application settings
     *
     * Updates the global application configuration settings.
     */
    static updateSettingsV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/settings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Load fixtures (V3)
     *
     * Development utility to populate the database with version 3 test data.
     */
    static loadFixturesV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/settings/fixtures',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V2SettingsService {
    /**
     * Load fixtures (V2)
     *
     * Development utility to populate the database with version 2 test data.
     */
    static loadFixtures(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/settings/fixtures',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorsService {
    /**
     * Get current collaborator profile
     *
     * Retrieves the profile information of the currently authenticated collaborator.
     */
    static getMe(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/me',
            ...options
        });
    }
    /**
     * Get list of collaborators
     *
     * Retrieves a paginated list of all collaborators in the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators',
            ...options
        });
    }
    /**
     * getUniqueLabelsV3
     *
     * Retrieves a list of unique labels used across collaborator profiles.
     */
    static getUniqueLabelsV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/labels',
            ...options
        });
    }
    /**
     * Get public collaborators
     *
     * Retrieves a list of collaborators whose profiles are set to public. Show bio info.
     */
    static getPublicCollaboratorsV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/public',
            ...options
        });
    }
    /**
     * getPublicCollaboratorV3
     *
     * Retrieves the public profile information of a specific collaborator.
     */
    static getPublicCollaboratorV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/{uuid}/public',
            ...options
        });
    }
    /**
     * Update a collaborator
     *
     * Updates the profile information for an existing collaborator.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update collaborator settings
     *
     * Updates personal settings and preferences for the authenticated collaborator.
     */
    static updateCollaboratorSettingsV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/{uuid}/collaboratorSettings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * updateBioV3
     *
     * Updates the biography/about section of the collaborator profile.
     */
    static updateBioV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/{uuid}/bio',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * updateConfirmSecurityTFDateV3
     *
     * Confirms or updates the security verification date for the collaborator.
     */
    static updateConfirmSecurityTfDateV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/{uuid}/confirmSecurityTF',
            ...options
        });
    }
}
export class V3CollaboratorsService {
    /**
     * Get current collaborator profile
     *
     * Retrieves the profile information of the currently authenticated collaborator.
     */
    static getMe(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/me',
            ...options
        });
    }
    /**
     * Get list of collaborators
     *
     * Retrieves a paginated list of all collaborators in the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators',
            ...options
        });
    }
    /**
     * getUniqueLabelsV3
     *
     * Retrieves a list of unique labels used across collaborator profiles.
     */
    static getUniqueLabelsV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/labels',
            ...options
        });
    }
    /**
     * Get public collaborators
     *
     * Retrieves a list of collaborators whose profiles are set to public. Show bio info.
     */
    static getPublicCollaboratorsV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/public',
            ...options
        });
    }
    /**
     * getPublicCollaboratorV3
     *
     * Retrieves the public profile information of a specific collaborator.
     */
    static getPublicCollaboratorV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/{uuid}/public',
            ...options
        });
    }
    /**
     * Update a collaborator
     *
     * Updates the profile information for an existing collaborator.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update collaborator settings
     *
     * Updates personal settings and preferences for the authenticated collaborator.
     */
    static updateCollaboratorSettingsV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/{uuid}/collaboratorSettings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * updateBioV3
     *
     * Updates the biography/about section of the collaborator profile.
     */
    static updateBioV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/{uuid}/bio',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * updateConfirmSecurityTFDateV3
     *
     * Confirms or updates the security verification date for the collaborator.
     */
    static updateConfirmSecurityTfDateV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborators/{uuid}/confirmSecurityTF',
            ...options
        });
    }
}
export class CollaboratorsVisionService {
    /**
     * Get vision for a collaborator
     *
     * Retrieves the vision information associated with a specific collaborator.
     */
    static getVisionForCollaborator(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-vision/collaborator/{uuid}',
            ...options
        });
    }
    /**
     * Create a collaborator vision
     *
     * Creates a new professional vision statement for a collaborator.
     */
    static createVision(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-vision',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update a collaborator vision
     *
     * Updates the details of an existing collaborator vision identified by its unique ID.
     */
    static updateVision(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-vision/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3CollaboratorVisionService {
    /**
     * Get vision for a collaborator
     *
     * Retrieves the vision information associated with a specific collaborator.
     */
    static getVisionForCollaborator(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-vision/collaborator/{uuid}',
            ...options
        });
    }
    /**
     * Create a collaborator vision
     *
     * Creates a new professional vision statement for a collaborator.
     */
    static createVision(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-vision',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update a collaborator vision
     *
     * Updates the details of an existing collaborator vision identified by its unique ID.
     */
    static updateVision(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-vision/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class PositionsService {
    /**
     * Get list of positions
     *
     * Retrieves a paginated list of positions from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/positions',
            ...options
        });
    }
    /**
     * Update a position
     *
     * Updates the details of an existing position identified by its unique ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/positions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3PositionsService {
    /**
     * Get list of positions
     *
     * Retrieves a paginated list of positions from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/positions',
            ...options
        });
    }
    /**
     * Update a position
     *
     * Updates the details of an existing position identified by its unique ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/positions/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorsGoalsService {
    /**
     * Get list of goals for all collaborators
     *
     * Retrieves a paginated list of goals for collaborators from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-goals',
            ...options
        });
    }
    /**
     * Create a new collaborator goal
     *
     * Creates a new collaborator goal record with the provided information.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-goals',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get list of goals for a specific collaborator
     *
     * Retrieves a list of goals associated with a specific collaborator.
     */
    static getManyForCollaboratorV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-goals/collaborator/{uuid}',
            ...options
        });
    }
    /**
     * Delete a collaborator goal
     *
     * Permanently removes a specific collaborator goal from the system.
     */
    static deleteOneV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-goals/{id}',
            ...options
        });
    }
    /**
     * Update a collaborator goal
     *
     * Updates the details of an existing collaborator goal identified by its unique ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-goals/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3CollaboratorGoalsService {
    /**
     * Get list of goals for all collaborators
     *
     * Retrieves a paginated list of goals for collaborators from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-goals',
            ...options
        });
    }
    /**
     * Create a new collaborator goal
     *
     * Creates a new collaborator goal record with the provided information.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-goals',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get list of goals for a specific collaborator
     *
     * Retrieves a list of goals associated with a specific collaborator.
     */
    static getManyForCollaboratorV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-goals/collaborator/{uuid}',
            ...options
        });
    }
    /**
     * Delete a collaborator goal
     *
     * Permanently removes a specific collaborator goal from the system.
     */
    static deleteOneV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-goals/{id}',
            ...options
        });
    }
    /**
     * Update a collaborator goal
     *
     * Updates the details of an existing collaborator goal identified by its unique ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-goals/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorFeedbacksService {
    /**
     * Get list of collaborator feedbacks
     *
     * Retrieves a paginated list of collaborator feedbacks from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-feedbacks',
            ...options
        });
    }
    /**
     * Create a new collaborator feedback
     *
     * Creates a new collaborator feedback record with the provided information.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-feedbacks',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * getSingleV3
     *
     * Retrieves a specific collaborator feedback entry by its ID.
     */
    static getSingleV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-feedbacks/single/{collaboratorUuid}',
            ...options
        });
    }
    /**
     * Get my feedbacks
     *
     * Retrieves all feedback entries received by the currently authenticated collaborator.
     */
    static getMyFeedbacksV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-feedbacks/my-feedbacks',
            ...options
        });
    }
}
export class V3CollaboratorFeedbacksService {
    /**
     * Get list of collaborator feedbacks
     *
     * Retrieves a paginated list of collaborator feedbacks from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-feedbacks',
            ...options
        });
    }
    /**
     * Create a new collaborator feedback
     *
     * Creates a new collaborator feedback record with the provided information.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-feedbacks',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * getSingleV3
     *
     * Retrieves a specific collaborator feedback entry by its ID.
     */
    static getSingleV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-feedbacks/single/{collaboratorUuid}',
            ...options
        });
    }
    /**
     * Get my feedbacks
     *
     * Retrieves all feedback entries received by the currently authenticated collaborator.
     */
    static getMyFeedbacksV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-feedbacks/my-feedbacks',
            ...options
        });
    }
}
export class Collaborators1On1Service {
    /**
     * Get list of collaborator 1on1s
     *
     * Retrieves a paginated list of collaborator 1on1s from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-1on1s',
            ...options
        });
    }
    /**
     * Create a new collaborator 1on1
     *
     * Creates a new collaborator 1on1 record with the provided information.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-1on1s',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * getManyForMeV3
     *
     * Retrieves a list of 1on1 meetings for the currently authenticated collaborator.
     */
    static getManyForMeV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-1on1s/me',
            ...options
        });
    }
    /**
     * Delete a collaborator 1on1
     *
     * Permanently removes a specific collaborator 1on1 from the system.
     */
    static deleteOneV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-1on1s/{uuid}',
            ...options
        });
    }
    /**
     * Update a collaborator 1on1
     *
     * Updates the details of an existing collaborator 1on1 identified by its unique ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-1on1s/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3Collaborator1On1Service {
    /**
     * Get list of collaborator 1on1s
     *
     * Retrieves a paginated list of collaborator 1on1s from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-1on1s',
            ...options
        });
    }
    /**
     * Create a new collaborator 1on1
     *
     * Creates a new collaborator 1on1 record with the provided information.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-1on1s',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * getManyForMeV3
     *
     * Retrieves a list of 1on1 meetings for the currently authenticated collaborator.
     */
    static getManyForMeV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-1on1s/me',
            ...options
        });
    }
    /**
     * Delete a collaborator 1on1
     *
     * Permanently removes a specific collaborator 1on1 from the system.
     */
    static deleteOneV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-1on1s/{uuid}',
            ...options
        });
    }
    /**
     * Update a collaborator 1on1
     *
     * Updates the details of an existing collaborator 1on1 identified by its unique ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-1on1s/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CollaboratorNotesService {
    /**
     * Get list of collaborator notes
     *
     * Retrieves a paginated list of collaborator notes from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-notes',
            ...options
        });
    }
    /**
     * Create a new collaborator note
     *
     * Creates a new collaborator note record with the provided information.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a collaborator note
     *
     * Permanently removes a specific collaborator note from the system.
     */
    static deleteOneV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-notes/{uuid}',
            ...options
        });
    }
    /**
     * Update a collaborator note
     *
     * Updates the details of an existing collaborator note identified by its unique ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-notes/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3CollaboratorNotesService {
    /**
     * Get list of collaborator notes
     *
     * Retrieves a paginated list of collaborator notes from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-notes',
            ...options
        });
    }
    /**
     * Create a new collaborator note
     *
     * Creates a new collaborator note record with the provided information.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a collaborator note
     *
     * Permanently removes a specific collaborator note from the system.
     */
    static deleteOneV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-notes/{uuid}',
            ...options
        });
    }
    /**
     * Update a collaborator note
     *
     * Updates the details of an existing collaborator note identified by its unique ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/collaborator-notes/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CostCategoriesService {
    /**
     * Get all cost categories
     *
     * Retrieves a complete list of all available cost categories.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/cost-categories',
            ...options
        });
    }
}
export class V2CostCategoriesService {
    /**
     * Get all cost categories
     *
     * Retrieves a complete list of all available cost categories.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/cost-categories',
            ...options
        });
    }
}
export class V2ProjectsService {
    /**
     * Get list of projects
     *
     * Retrieves a paginated list of all projects registered in the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/projects',
            ...options
        });
    }
    /**
     * Get project report
     *
     * Generates and retrieves a detailed report for a specific project identified by its UUID.
     */
    static getProjectReport(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/projects-report/{uuid}',
            ...options
        });
    }
    /**
     * Get project report
     *
     * Generates and retrieves a detailed report for a specific project identified by its UUID.
     */
    static getProjectReport2(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/projects-report/{uuid}',
            ...options
        });
    }
    /**
     * Update project report
     *
     * Updates the report data for a specific project report identified by its UUID.
     */
    static updateProjectReport(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/projects-report/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update project report
     *
     * Updates the report data for a specific project report identified by its UUID.
     */
    static updateProjectReport2(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/projects-report/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update a project
     *
     * Updates the core information of an existing project identified by its numeric ID.
     */
    static updateOne(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/projects/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update a project
     *
     * Updates the core information of an existing project identified by its numeric ID.
     */
    static updateOne2(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/projects/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3ProjectsService {
    /**
     * Get list of projects
     *
     * Retrieves a paginated list of all projects registered in the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/projects',
            ...options
        });
    }
}
export class V3SonarCloudMetricsService {
    /**
     * Get SonarCloud metrics
     *
     * Retrieves the latest SonarCloud metrics for monitored projects.
     */
    static getMetrics(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/sonar-cloud-metrics',
            ...options
        });
    }
    /**
     * Fetch and save SonarCloud metrics
     *
     * Triggers an on-demand fetch of SonarCloud metrics and persists them in the database.
     */
    static fetchMetricsFromSonarCloudAndSave(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/sonar-cloud-metrics',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class PermissionsService {
    /**
     * Get all permissions
     *
     * Retrieves a list of all possible system permissions for access control.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/permissions',
            ...options
        });
    }
}
export class V2PermissionsService {
    /**
     * Get all permissions
     *
     * Retrieves a list of all possible system permissions for access control.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/permissions',
            ...options
        });
    }
}
export class SitdownsService {
    /**
     * Delete a sitdown
     *
     * Permanently removes a specific sitdown from the system.
     */
    static deleteOne(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns/{id}',
            ...options
        });
    }
    /**
     * Get sitdown by ID
     *
     * Retrieves detailed information about a specific sitdown using its unique ID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns/{id}',
            ...options
        });
    }
    /**
     * Update a sitdown
     *
     * Updates the details of an existing sitdown identified by its unique ID.
     */
    static updateOne(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get list of sitdowns
     *
     * Retrieves a paginated list of sitdowns from the system.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns',
            ...options
        });
    }
    /**
     * Create a new sitdown
     *
     * Creates a new sitdown record with the provided information.
     */
    static createOne(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V2SitdownsService {
    /**
     * Delete a sitdown
     *
     * Permanently removes a specific sitdown from the system.
     */
    static deleteOne(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns/{id}',
            ...options
        });
    }
    /**
     * Get sitdown by ID
     *
     * Retrieves detailed information about a specific sitdown using its unique ID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns/{id}',
            ...options
        });
    }
    /**
     * Update a sitdown
     *
     * Updates the details of an existing sitdown identified by its unique ID.
     */
    static updateOne(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get list of sitdowns
     *
     * Retrieves a paginated list of sitdowns from the system.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns',
            ...options
        });
    }
    /**
     * Create a new sitdown
     *
     * Creates a new sitdown record with the provided information.
     */
    static createOne(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class SitdownNotesService {
    /**
     * Delete a sitdown note
     *
     * Permanently removes a specific sitdown note from the system.
     */
    static deleteOne(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-notes/{id}',
            ...options
        });
    }
    /**
     * Get sitdown note by ID
     *
     * Retrieves detailed information about a specific sitdown note using its unique ID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-notes/{id}',
            ...options
        });
    }
    /**
     * Update a sitdown note
     *
     * Updates the details of an existing sitdown note identified by its unique ID.
     */
    static updateOne(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-notes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get list of sitdown notes
     *
     * Retrieves a paginated list of sitdown notes from the system.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-notes',
            ...options
        });
    }
    /**
     * Create a new sitdown note
     *
     * Creates a new sitdown note record with the provided information.
     */
    static createOne(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V2SitdownNotesService {
    /**
     * Delete a sitdown note
     *
     * Permanently removes a specific sitdown note from the system.
     */
    static deleteOne(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-notes/{id}',
            ...options
        });
    }
    /**
     * Get sitdown note by ID
     *
     * Retrieves detailed information about a specific sitdown note using its unique ID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-notes/{id}',
            ...options
        });
    }
    /**
     * Update a sitdown note
     *
     * Updates the details of an existing sitdown note identified by its unique ID.
     */
    static updateOne(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-notes/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get list of sitdown notes
     *
     * Retrieves a paginated list of sitdown notes from the system.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-notes',
            ...options
        });
    }
    /**
     * Create a new sitdown note
     *
     * Creates a new sitdown note record with the provided information.
     */
    static createOne(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-notes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class SitdownTimesService {
    /**
     * Delete a sitdown time
     *
     * Permanently removes a specific sitdown time from the system.
     */
    static deleteOne(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-times/{id}',
            ...options
        });
    }
    /**
     * Get sitdown time by ID
     *
     * Retrieves detailed information about a specific sitdown time using its unique ID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-times/{id}',
            ...options
        });
    }
    /**
     * Update a sitdown time
     *
     * Updates the details of an existing sitdown time identified by its unique ID.
     */
    static updateOne(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-times/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get list of sitdown times
     *
     * Retrieves a paginated list of sitdown times from the system.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-times',
            ...options
        });
    }
    /**
     * Create a new sitdown time
     *
     * Creates a new sitdown time record with the provided information.
     */
    static createOne(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-times',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V2SitdownTimesService {
    /**
     * Delete a sitdown time
     *
     * Permanently removes a specific sitdown time from the system.
     */
    static deleteOne(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-times/{id}',
            ...options
        });
    }
    /**
     * Get sitdown time by ID
     *
     * Retrieves detailed information about a specific sitdown time using its unique ID.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-times/{id}',
            ...options
        });
    }
    /**
     * Update a sitdown time
     *
     * Updates the details of an existing sitdown time identified by its unique ID.
     */
    static updateOne(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-times/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get list of sitdown times
     *
     * Retrieves a paginated list of sitdown times from the system.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-times',
            ...options
        });
    }
    /**
     * Create a new sitdown time
     *
     * Creates a new sitdown time record with the provided information.
     */
    static createOne(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdown-times',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class SitdownsRatingsService {
    /**
     * Get list of sitdown ratings
     *
     * Retrieves a paginated list of sitdown ratings from the system.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns-ratings',
            ...options
        });
    }
    /**
     * Create a new sitdown rating
     *
     * Creates a new sitdown rating record with the provided information.
     */
    static createOne(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns-ratings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V2SitdownsRatingsService {
    /**
     * Get list of sitdown ratings
     *
     * Retrieves a paginated list of sitdown ratings from the system.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns-ratings',
            ...options
        });
    }
    /**
     * Create a new sitdown rating
     *
     * Creates a new sitdown rating record with the provided information.
     */
    static createOne(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/sitdowns-ratings',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class DocumentsService {
    /**
     * Get list of documents
     *
     * Retrieves a paginated list of documents from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/documents',
            ...options
        });
    }
    /**
     * Create a new document
     *
     * Creates a new document record with the provided information.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/documents',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a document
     *
     * Permanently removes a specific document from the system.
     */
    static deleteOneV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/documents/{uuid}',
            ...options
        });
    }
    /**
     * Update a document
     *
     * Updates the details of an existing document identified by its unique ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/documents/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3DocumentsService {
    /**
     * Get list of documents
     *
     * Retrieves a paginated list of documents from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/documents',
            ...options
        });
    }
    /**
     * Create a new document
     *
     * Creates a new document record with the provided information.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/documents',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a document
     *
     * Permanently removes a specific document from the system.
     */
    static deleteOneV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/documents/{uuid}',
            ...options
        });
    }
    /**
     * Update a document
     *
     * Updates the details of an existing document identified by its unique ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/documents/{uuid}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class EnumsService {
    /**
     * Get all enums
     *
     * Retrieves a comprehensive list of all enumerations used across the application.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/enums',
            ...options
        });
    }
}
export class V2EnumsService {
    /**
     * Get all enums
     *
     * Retrieves a comprehensive list of all enumerations used across the application.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/enums',
            ...options
        });
    }
}
export class V2ExampleService {
    /**
     * Delete an example
     *
     * Permanently removes an example record from the database.
     */
    static deleteOne(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/example/{id}',
            ...options
        });
    }
    /**
     * Get example by ID
     *
     * Retrieves full details of a single example record using its unique identifier.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/example/{id}',
            ...options
        });
    }
    /**
     * Update an example
     *
     * Updates the details of an existing example record identified by its ID.
     */
    static updateOne(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/example/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get all examples
     *
     * Retrieves a list of all example records available for demonstration.
     */
    static getMany(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/example',
            ...options
        });
    }
    /**
     * Create a new example
     *
     * Creates and persists a new example record with the provided data.
     */
    static createOne(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/example',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class GameService {
    /**
     * Get game data for a month
     *
     * Retrieves game-related data and statistics for a specified month.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/{month}',
            ...options
        });
    }
    /**
     * Update game for a month
     *
     * Updates game-related configuration or data for a specific month.
     */
    static updateGame(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/{month}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get donated collaborators for a month
     *
     * Retrieves a list of collaborators who donated points/XP in a specified month.
     */
    static getDonatedCollaborators(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/donated-collaborators/{month}',
            ...options
        });
    }
    /**
     * Get donor collaborators for a month
     *
     * Retrieves a list of collaborators who are eligible as donors for a specified month.
     */
    static getDonorUsers(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/donors/{month}',
            ...options
        });
    }
    /**
     * Create bonus XP for a month
     *
     * Assigns bonus experience points (XP) to users for their performance in a specific month.
     */
    static createBonusXp(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/{month}/bonus-experience',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete bonus XP
     *
     * Removes previously assigned bonus XP records.
     */
    static deleteBonusXp(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/{month}/bonus-experience/{id}',
            ...options
        });
    }
}
export class V2GameService {
    /**
     * Get game data for a month
     *
     * Retrieves game-related data and statistics for a specified month.
     */
    static getOne(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/{month}',
            ...options
        });
    }
    /**
     * Update game for a month
     *
     * Updates game-related configuration or data for a specific month.
     */
    static updateGame(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/{month}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get donated collaborators for a month
     *
     * Retrieves a list of collaborators who donated points/XP in a specified month.
     */
    static getDonatedCollaborators(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/donated-collaborators/{month}',
            ...options
        });
    }
    /**
     * Get donor collaborators for a month
     *
     * Retrieves a list of collaborators who are eligible as donors for a specified month.
     */
    static getDonorUsers(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/donors/{month}',
            ...options
        });
    }
    /**
     * Create bonus XP for a month
     *
     * Assigns bonus experience points (XP) to users for their performance in a specific month.
     */
    static createBonusXp(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/{month}/bonus-experience',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete bonus XP
     *
     * Removes previously assigned bonus XP records.
     */
    static deleteBonusXp(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/game/{month}/bonus-experience/{id}',
            ...options
        });
    }
}
export class HealthService {
    /**
     * Check application health status
     *
     * Returns the current health status of the application, including database connectivity.
     */
    static healthCheck(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/health',
            ...options
        });
    }
}
export class MerchService {
    /**
     * Submit a merch request
     *
     * Submits a new request for company merchandise.
     */
    static merchRequest(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/merch-request',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3MerchRequestService {
    /**
     * Submit a merch request
     *
     * Submits a new request for company merchandise.
     */
    static merchRequest(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/merch-request',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class OfficeAbsencesService {
    /**
     * Get office absence changes
     *
     * Retrieves a history of changes made to office absence records.
     */
    static getChanges(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/office-absences/changes',
            ...options
        });
    }
    /**
     * getBackupApproverV3
     *
     * Retrieves the assigned backup approver for office absences.
     */
    static getBackupApproverV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences/backup-approver',
            ...options
        });
    }
    /**
     * getStatisticsV3
     *
     * Calculates and retrieves statistics related to office absences.
     */
    static getStatisticsV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences/statistics',
            ...options
        });
    }
    /**
     * Get list of office absences
     *
     * Retrieves a list of scheduled office absences.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences',
            ...options
        });
    }
    /**
     * Create a new office absence
     *
     * Registers a new office absence (e.g., vacation, sick leave).
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    static officeAbsencesControllerCreateUpdateMessages(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences/create-updated-messages',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update an office absence
     *
     * Updates the details of an existing office absence.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update an office absence by token
     *
     * Updates an office absence record using a secure access token (typically from an email link).
     */
    static updateOneByTokenV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences/{id}/by-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V2OfficeAbsencesService {
    /**
     * Get office absence changes
     *
     * Retrieves a history of changes made to office absence records.
     */
    static getChanges(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v2/office-absences/changes',
            ...options
        });
    }
}
export class V3OfficeAbsencesService {
    /**
     * getBackupApproverV3
     *
     * Retrieves the assigned backup approver for office absences.
     */
    static getBackupApproverV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences/backup-approver',
            ...options
        });
    }
    /**
     * getStatisticsV3
     *
     * Calculates and retrieves statistics related to office absences.
     */
    static getStatisticsV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences/statistics',
            ...options
        });
    }
    /**
     * Get list of office absences
     *
     * Retrieves a list of scheduled office absences.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences',
            ...options
        });
    }
    /**
     * Create a new office absence
     *
     * Registers a new office absence (e.g., vacation, sick leave).
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    static officeAbsencesControllerCreateUpdateMessages(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences/create-updated-messages',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update an office absence
     *
     * Updates the details of an existing office absence.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update an office absence by token
     *
     * Updates an office absence record using a secure access token (typically from an email link).
     */
    static updateOneByTokenV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/office-absences/{id}/by-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class SubstituteGroupsService {
    /**
     * getAllV3
     *
     * Retrieves a complete list of substitute groups (Version 3).
     */
    static getAllV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/substitute-groups',
            ...options
        });
    }
    /**
     * Create a new substitute group
     *
     * Creates a new substitute group record with the provided information.
     */
    static createGroupV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/substitute-groups',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a substitute group
     *
     * Permanently removes a specific substitute group from the system.
     */
    static deleteGroupV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/substitute-groups/{id}',
            ...options
        });
    }
    /**
     * Update a substitute group
     *
     * Updates the details of an existing substitute group identified by its unique ID.
     */
    static updateGroupV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/substitute-groups/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3SubstituteGroupsService {
    /**
     * getAllV3
     *
     * Retrieves a complete list of substitute groups (Version 3).
     */
    static getAllV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/substitute-groups',
            ...options
        });
    }
    /**
     * Create a new substitute group
     *
     * Creates a new substitute group record with the provided information.
     */
    static createGroupV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/substitute-groups',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a substitute group
     *
     * Permanently removes a specific substitute group from the system.
     */
    static deleteGroupV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/substitute-groups/{id}',
            ...options
        });
    }
    /**
     * Update a substitute group
     *
     * Updates the details of an existing substitute group identified by its unique ID.
     */
    static updateGroupV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/substitute-groups/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TestNotificationService {
    /**
     * testEmailNotificationV3
     *
     * Sends a test email to verify the email notification system is working correctly.
     */
    static testEmailNotificationV3(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/test-notification/email',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * testSlackNotificationV3
     *
     * Sends a test message to Slack to verify the Slack integration.
     */
    static testSlackNotificationV3(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/test-notification/slack',
            ...options
        });
    }
}
export class V3TestNotificationService {
    /**
     * testEmailNotificationV3
     *
     * Sends a test email to verify the email notification system is working correctly.
     */
    static testEmailNotificationV3(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/test-notification/email',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * testSlackNotificationV3
     *
     * Sends a test message to Slack to verify the Slack integration.
     */
    static testSlackNotificationV3(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/test-notification/slack',
            ...options
        });
    }
}
export class WorkingTimeRecordsService {
    /**
     * Get list of working time records
     *
     * Retrieves a paginated list of working time records from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-records',
            ...options
        });
    }
    /**
     * Get working time records summary
     *
     * Retrieves a summarized overview of working time records for a given period.
     */
    static getSummaryV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-records/summary',
            ...options
        });
    }
    /**
     * getByMonthV3
     *
     * Retrieves working time records filtered by a specific month.
     */
    static getByMonthV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-records/{month}',
            ...options
        });
    }
    /**
     * Delete a working time record
     *
     * Permanently removes a specific working time record from the system.
     */
    static deleteItem(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-records/{id}/{legalType}',
            ...options
        });
    }
    /**
     * regenerateByMonthV3
     *
     * Triggers a regeneration of working time records for a specific month.
     */
    static regenerateByMonthV3(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-records/{month}/regenerate',
            ...options
        });
    }
}
export class V3WorkingTimeRecordsService {
    /**
     * Get list of working time records
     *
     * Retrieves a paginated list of working time records from the system.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-records',
            ...options
        });
    }
    /**
     * Get working time records summary
     *
     * Retrieves a summarized overview of working time records for a given period.
     */
    static getSummaryV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-records/summary',
            ...options
        });
    }
    /**
     * getByMonthV3
     *
     * Retrieves working time records filtered by a specific month.
     */
    static getByMonthV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-records/{month}',
            ...options
        });
    }
    /**
     * Delete a working time record
     *
     * Permanently removes a specific working time record from the system.
     */
    static deleteItem(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-records/{id}/{legalType}',
            ...options
        });
    }
    /**
     * regenerateByMonthV3
     *
     * Triggers a regeneration of working time records for a specific month.
     */
    static regenerateByMonthV3(options) {
        return (options.client ?? client).post({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-records/{month}/regenerate',
            ...options
        });
    }
    /**
     * Update a working time record item
     *
     * Updates the details of an existing working time record item identified by its unique ID.
     */
    static update(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-record-items/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update working time record item status
     *
     * Updates the status (e.g., approved, rejected) of a specific working time record item.
     */
    static updateStatus(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-record-items/{id}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class WorkingTimeRecordItemsService {
    /**
     * Update a working time record item
     *
     * Updates the details of an existing working time record item identified by its unique ID.
     */
    static update(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-record-items/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Update working time record item status
     *
     * Updates the status (e.g., approved, rejected) of a specific working time record item.
     */
    static updateStatus(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/working-time-record-items/{id}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class WorklogsService {
    /**
     * Get worklog category sum
     *
     * Calculates and retrieves the total time spent per worklog category.
     */
    static getCategorySumV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/category-sum',
            ...options
        });
    }
    /**
     * Get worklog year statistics
     *
     * Retrieves annual statistics and summaries for worklogs.
     */
    static getYearStatsV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/year-stats/{toDate}',
            ...options
        });
    }
    /**
     * Delete a worklog
     *
     * Removes a specific worklog entry from the system.
     */
    static deleteOneV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/{id}',
            ...options
        });
    }
    /**
     * Get worklog by ID
     *
     * Retrieves detailed information about a specific worklog entry.
     */
    static getOneV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/{id}',
            ...options
        });
    }
    /**
     * Update a worklog
     *
     * Updates an existing worklog entry identified by its ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get list of worklogs
     *
     * Retrieves a paginated list of worklogs, optionally filtered by various criteria.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs',
            ...options
        });
    }
    /**
     * Create a new worklog
     *
     * Records a new worklog entry for a user, specifying time spent and project.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    static worklogsControllerCreateUpdateMessages(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/create-updated-messages',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3WorklogsService {
    /**
     * Get worklog category sum
     *
     * Calculates and retrieves the total time spent per worklog category.
     */
    static getCategorySumV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/category-sum',
            ...options
        });
    }
    /**
     * Get worklog year statistics
     *
     * Retrieves annual statistics and summaries for worklogs.
     */
    static getYearStatsV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/year-stats/{toDate}',
            ...options
        });
    }
    /**
     * Delete a worklog
     *
     * Removes a specific worklog entry from the system.
     */
    static deleteOneV3(options) {
        return (options.client ?? client).delete({
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/{id}',
            ...options
        });
    }
    /**
     * Get worklog by ID
     *
     * Retrieves detailed information about a specific worklog entry.
     */
    static getOneV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/{id}',
            ...options
        });
    }
    /**
     * Update a worklog
     *
     * Updates an existing worklog entry identified by its ID.
     */
    static updateOneV3(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get list of worklogs
     *
     * Retrieves a paginated list of worklogs, optionally filtered by various criteria.
     */
    static getManyV3(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs',
            ...options
        });
    }
    /**
     * Create a new worklog
     *
     * Records a new worklog entry for a user, specifying time spent and project.
     */
    static createOneV3(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    static worklogsControllerCreateUpdateMessages(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/work-logs/create-updated-messages',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class OpenAiService {
    /**
     * Validate a goal using OpenAI
     *
     * Uses OpenAI AI models to validate the content and quality of a goal.
     */
    static validateGoal(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/validate-goal',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Validate a vision using OpenAI
     *
     * Uses OpenAI AI models to validate the content and quality of a vision.
     */
    static validateVision(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/validate-vision',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Validate a 1on1 note using OpenAI
     *
     * Uses OpenAI AI models to validate the content and quality of a 1on1 note.
     */
    static validate1On1(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/validate-1on1',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class V3OpenAiService {
    /**
     * Validate a goal using OpenAI
     *
     * Uses OpenAI AI models to validate the content and quality of a goal.
     */
    static validateGoal(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/validate-goal',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Validate a vision using OpenAI
     *
     * Uses OpenAI AI models to validate the content and quality of a vision.
     */
    static validateVision(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/validate-vision',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Validate a 1on1 note using OpenAI
     *
     * Uses OpenAI AI models to validate the content and quality of a 1on1 note.
     */
    static validate1On1(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ name: 'tfpl-id-token', type: 'apiKey' }],
            url: '/{tenant}/hub/v3/{company}/validate-1on1',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
